import React from 'react';
import { Tabs } from 'antd';
import { TabPaneProps } from 'antd/lib/tabs';
import style from './tabs.module.scss';
import classNames from 'classnames';
const { TabPane } = Tabs;
export function SiriusTabs(props) {
    let { type, size, bgmode = 'white', className, tabBarGutter = 12 } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Tabs, Object.assign({}, props, { type: type, tabBarGutter: tabBarGutter, className: classNames({
                [style.white]: bgmode === 'white' && type === 'capsule',
                [style.gray]: bgmode === 'gray' && type === 'capsule',
                capsule: type === 'capsule',
                [style.siriusTabs]: true,
            }, className), size: (size || 'default') }))));
}
SiriusTabs.TabPane = TabPane;
export { TabPaneProps };
